import { businessPlanAxios } from 'services/controllers/businessPlan';

import * as t from './types';

export const ProductionApi = {
  getProductionCalculations: async (params: t.IProductionCalculationsParams) => {
    const { businessPlanId, unit, productionRequestData } = params;
    const { data } = await businessPlanAxios.put<t.IProductionCalculationResponse>(
      `/${businessPlanId}/production/${unit}`,
      productionRequestData,
    );
    return data;
  },

  getProductionReCalculations: async (params: t.IProductionReCalculationsParams) => {
    const { businessPlanId, unit, productionRequestData } = params;
    const { data } = await businessPlanAxios.put<t.IProductionReCalculationResponse>(
      `/${businessPlanId}/production/recalculate/${unit}`,
      productionRequestData,
    );
    return data;
  },
};
